/* eslint-disable @typescript-eslint/no-explicit-any */
import styled, { css } from 'styled-components';
import { getFlexAlignment } from '../utils';
import { decimalToHexString } from '../../tools/utils';
export const cellFlexAlignmentStyles = css `
  ${({ alignment }) => `
    ${alignment ? `justify-content: ${getFlexAlignment(alignment)};` : ''}
  `}
`;
// specificity increased to override the nth-child selector (in StyledTable)
const cellAlignmentStyles = css `
  ${({ alignment }) => `
    ${alignment ? `&&& { text-align: ${alignment}; }` : ''}
  `}
`;
const sharedCellStyles = css `
  ${({ isFooterCell }) => `
    font-weight: ${isFooterCell ? 'bold' : 'normal'};
  `}
  ${cellAlignmentStyles}
`;
export const StyledTH = styled.th `
  ${({ isSortable, theme: { colors } }) => isSortable
    ? `
        /* padding is added to the element inside of the th (in HeaderCell.tsx) */
        padding: 0 !important;

        &:hover {
          background-color: ${colors['slate-500']}${decimalToHexString(0.08)};
        }
      `
    : ''}
  ${sharedCellStyles}
`;
export const StyledTD = styled.td `
  ${sharedCellStyles}
`;
// min clickable area must be 44px
export const baseColumnHeaderStyles = css `
  height: 44px;
  min-width: 44px;
  font-weight: bold;
  text-transform: capitalize;
  background: transparent;
  border: none;
`;
// generic type doesn't matter for the props we're picking
export const StyledTable = styled.table `
  ${({ disableContainer, fullWidth, theme: { colors, fonts, font, space }, }) => `
    font-family: ${fonts.regular};
    
    border-collapse: collapse;
    border-spacing: 0;
    border-style: hidden;
    border-radius: 4px;
    overflow: hidden;
    margin: auto;

    ${fullWidth ? 'width: 100%;' : ''}

    ${!disableContainer
    ? `box-shadow:
            0 0 0 1px ${colors['gray-300']},
            0 2px 4px -2px rgba(0,0,0,0.16),
            0 5px 8px -4px rgba(0,0,0,0.16);`
    : ''}

    thead {
      background: ${colors['slate-100']};
      
      tr {
        th, th > button {
          ${baseColumnHeaderStyles}
        }
      }
    }

    tbody {
      background: ${colors.white};

      tr {
        background: inherit;
        border-bottom: 1px solid ${colors['gray-300']};

        th {
          font-weight: normal;

          &:focus {
            outline: none;
          }
        }

        td {
          font-weight: normal;
          text-transform: none;
          
          &:nth-child(n + 2) {
            text-align: right;
          }

          &:focus {
            outline: none;
          }
        }

        dl {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          row-gap: ${space.sm};
          /*
            This padding is added to the global td padding for a total drawer padding of:
            padding: md (md + md);
          */
          padding: ${space.md};
          margin: 0;

          div {
            display: flex;
            flex-direction: column;
            align-items: flex-start;;

            dt {
              font-size: ${font.body.sm.size};
              line-height: ${font.body.sm.lineHeight};
              color: ${colors['gray-700']};

              &:focus {
                outline: none;
              }
            }

            dd {
              font-size: ${font.body.md.size};
              font-weight: bold;
              line-height: ${font.body.md.lineHeight};
              color: ${colors['gray-900']};
              margin: 0;
            }
          }
        }
      }
    }

    tr {
      height: 48px;
    }

    th, td {
      background: inherit;
      font-size: ${font.body.sm.size};
      line-height: ${font.body.sm.lineHeight};
      white-space: normal;
      padding: 0 ${space.md};
    }

    tfoot {
      background: ${colors.white};
    }

    /* acts as border-bottom (since collapsing table borders) */
    &:after {
      content: '';
      width: 100%;      
      border-bottom: 1px solid ${colors['gray-300']};
    }
  `}
`;
//# sourceMappingURL=styles.js.map